const voucherPositions = Object.freeze({
  TOP: 0,
  BOTTOM: 1
})

const voucherPositionsLabels = Object.freeze({
  0: 'CampaignForm_VoucherType_Top',
  1: 'CampaignForm_VoucherType_Bottom'
})

export { voucherPositionsLabels, voucherPositions }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/VoucherPositionsEnum.js